import axiosAuthenticated from "../../api/axiosAuthenticated";
import { isNotNullOrUndefined } from "../../shared/objectUtils";

const featuresPath = '/features';

//#region Features Methods

export const getAllFeatures = async () => {
    const featuresRes = await axiosAuthenticated.get(featuresPath, { params: { page: 1, size: 1000000, isDeleted: false } });
    if (featuresRes && featuresRes.status === 200) {
        return featuresRes.data.data;
    }

    return [];
};

export const getFeatures = async (searchParams = {}, pagination = {}) => {
    const featuresRes = await axiosAuthenticated.get(featuresPath, { params: { ...searchParams } });
    if (featuresRes && featuresRes.status === 200) {
        const features = featuresRes.data.data;
        const otherData = featuresRes.data;

        // Read total count from server
        pagination.total = otherData.totalCount;
        pagination.current = otherData.currentPage;
        pagination.pageSize = isNotNullOrUndefined(searchParams.size) ? searchParams.size : pagination.pageSize;
        pagination.totalPages = otherData.totalPages;

        return { data: features, searchParams: searchParams, pagination: pagination };
    }

    return { data: [], searchParams: searchParams, pagination: pagination };
};

export const getFeature = async (id) => {
    const featuresRes = await axiosAuthenticated.get(featuresPath + `/${id}`);
    if (featuresRes && featuresRes.status === 200) {
        return featuresRes.data;
    }

    return null;
};

export const addFeature = async (payload) => {
    const featuresRes = await axiosAuthenticated.post(featuresPath, { ...payload });
    if (featuresRes && featuresRes.status === 201) {
        return featuresRes.data;
    }

    return null;
};

export const updateFeature = async (id, payload) => {
    const featuresRes = await axiosAuthenticated.put(featuresPath + `/${id}`, { ...payload });
    if (featuresRes && featuresRes.status === 200) {
        return featuresRes.data;
    }

    return null;
};

export const removeFeature = async (id) => {
    const featuresRes = await axiosAuthenticated.put(featuresPath + `/${id}`, { isDeleted: true });
    if (featuresRes && featuresRes.status === 200) {
        return featuresRes.data;
    }

    return null;
};

//#endregion